'use strict';

var App = require('app');
var Misc = require('utils/misc');
var Devices = require('models/devices');

var API = {
    getConnectedDevices: function (id) {
        return Misc.deferredFct(function (defer) {
            App.ajax({
                method: 'GET',
                url: '/api/v1/devices/' + id + '/connected',
                success: function (data) {
                    defer.resolve(new Devices.Collection(data).toJSON());
                },
                error: function () {
                    defer.resolve(undefined);
                },
            });
        });
    },

    getDeviceConfigurations: function (list) {
        return Misc.deferredFct(function (defer) {
            App.ajax({
                method: 'GET',
                url: '/api/v1/devices/configurations?list=' + encodeURIComponent(list.join(',')),
                success: function (data) {
                    defer.resolve(new Devices.Collection(data).toJSON());
                },
                error: function () {
                    defer.resolve(undefined);
                },
            });
        });
    },

    saveDeviceConfiguration: function (id, values) {
        return Misc.deferredFct(function (defer) {
            var postData = {
                values: Misc.selectWhere(values, undefined, function (valueStr) {
                    var parts = valueStr.split('_');
                    return {
                        device_id: parseInt(parts[0]),
                        type: parts[1],
                        nr: parseInt(parts[2]),
                    };
                }),
            };
            App.ajax({
                method: 'POST',
                url: '/api/v1/devices/' + id + '/overview-values',
                data: JSON.stringify(postData),
                success: function (data) {
                    defer.resolve(true);
                },
                error: function () {
                    defer.resolve(undefined);
                },
            });
        });
    },

    loadDeviceConfiguration: function (id) {
        return Misc.deferredFct(function (defer) {
            App.ajax({
                method: 'GET',
                url: '/api/v1/devices/' + id + '/overview-values',
                success: function (data) {
                    return defer.resolve(data);
                },
                error: function () {
                    return defer.resolve(undefined);
                },
            });
        });
    },

    getDeviceOverviewValues: function (id) {
        return Misc.deferredFct(function (defer) {
            App.ajax({
                method: 'GET',
                url: '/api/v1/devices/' + id + '/sensorvalues?overview=true',
                success: function (data) {
                    defer.resolve(data);
                },
                error: function () {
                    defer.resolve(undefined);
                },
            });
        });
    },
};

App.reqres.setHandler('devices:connected', function (id) {
    return API.getConnectedDevices(id);
});

App.reqres.setHandler('devices:configurations', function (devices) {
    return API.getDeviceConfigurations(devices);
});

App.reqres.setHandler('devices:overview:values:save', function (id, values) {
    return API.saveDeviceConfiguration(id, values);
});

App.reqres.setHandler('devices:overview:values:load', function (id) {
    return API.loadDeviceConfiguration(id);
});

App.reqres.setHandler('devices:overview:values:get', function (id) {
    return API.getDeviceOverviewValues(id);
});
